module.exports = __webpack_public_path__ + "img/main-list_10.f45981ec.jpg";